var InvoiceStatusEnum;
(function (InvoiceStatusEnum) {
    InvoiceStatusEnum["Due"] = "Due";
    InvoiceStatusEnum["Overdue"] = "Overdue";
    InvoiceStatusEnum["Paid"] = "Paid";
    InvoiceStatusEnum["Void"] = "Void";
    InvoiceStatusEnum["WrittenOff"] = "WrittenOff";
    InvoiceStatusEnum["Disputed"] = "Disputed";
})(InvoiceStatusEnum || (InvoiceStatusEnum = {}));

export { InvoiceStatusEnum };
